<template>
<div>
    <el-descriptions title="基础信息" v-if="isShowDetail">
        <el-descriptions-item label="案件号">{{detailObj.caseSn}}</el-descriptions-item>
        <el-descriptions-item label="车牌号">{{detailObj.current.plateNo}}</el-descriptions-item>
        <el-descriptions-item label="车型">{{detailObj.factory.vehicleModel}}</el-descriptions-item>
        <el-descriptions-item label="保险公司">{{ detailObj.insurance.insureCompany }} </el-descriptions-item>
    </el-descriptions>   
  
    <el-form label-width="120px" :model="dataForm" :rules="rules" ref="refDataForm">  
        <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
            
                <el-col :span="6">
                    <el-form-item label="委托协议照片">
                        <material-picker v-model="dataForm.commitmentUrl">
                        </material-picker>
                    </el-form-item>
                </el-col>    
                
                <el-col :span="6">
                <el-form-item label="登记证书照片" >
                   
                    <material-picker v-model="dataForm.registrationUrl">

                    </material-picker>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="行驶证照片">
                    <material-picker v-model="dataForm.drivingLicenseUrl">
                    </material-picker>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="车主身份证照片">
                        <material-picker v-model="dataForm.identityCardUrl">

                        </material-picker>
                    </el-form-item>
                </el-col>
            </el-collapse-item>
        


        
            <el-collapse-item name="5">
                <el-row>
                    
                    <el-col :span="6">
                        <el-form-item label="交管12123截图">
                            <material-picker v-model="dataForm.trafficScreenshotUrl">

                            </material-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="电子保单">
                            <material-picker v-model="dataForm.policyUrl">

                            </material-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="过户视频">
                            <material-picker v-model="dataForm.transferUrl">

                            </material-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="备注">
                            <el-input type="textarea" v-model="dataForm.remark">

                            </el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

             

            </el-collapse-item>
        

         



            <el-row type="flex" justify="center">
                <el-button type="primary" @click="handleValidAndSubmit"> 入库</el-button>
            </el-row>
        
        </el-collapse>
        
    </el-form>
    
</div>
</template>
<script>

import MaterialPicker from "@/components/Material/picker.vue"
import {getCase} from '@/api/vehicle/case';
import {addupdateVehicleStoreage} from '@/api/vehicle/case'
export default {
    components:{MaterialPicker},
    created(){
        const caseId=this.$route.query.caseid;
    
        if(caseId){
            this.dataForm.caseId=caseId;
            this.handleGetDetail(caseId);
        }
    },
    data(){
        return{
            isShowDetail:false,
            activeNames:['1','2','3','4','5','6','7','8'],
            detailObj:{},
            dataForm:{
                caseId:0,
                commitmentUrl:[],
                registrationUrl:[],
                drivingLicenseUrl:[],
                identityCardUrl:[],
                trafficScreenshotUrl:[],
                policyUrl:[],
                transferUrl:[],
                remark:'',
            },

            rules: {
                    commitmentUrl: [
                        { required: true, message: '定损员电话不能为空', trigger: 'blur' },
                    ],
                    registrationUrl: [
                        { required: true, message: '定损员姓名不能为空', trigger: 'blur' },
                    ],
                    drivingLicenseUrl: [
                        { required: true, message: '车主姓名不能为空', trigger: 'blur' },
                    ],
                    identityCardUrl: [
                        { required: true, message: '车主电话不能为空', trigger: 'blur' },
                    ],
                    trafficScreenshotUrl: [
                        { required: true, message: '车主电话不能为空', trigger: 'blur' },
                    ],
                    policyUrl: [
                        { required: true, message: '车主电话不能为空', trigger: 'blur' },
                    ],
                    transferUrl: [
                        { required: true, message: '车主电话不能为空', trigger: 'blur' },
                    ],
            } 
        }
    },
    methods:{
         //显示素材详情
        handleGetDetail(caseId){
            // 获取详情
            getCase(caseId)
            .then(res=>{
                this.detailObj=res.data;
                this.isShowDetail=true;
            })
        },
        // 先进行验证
        handleValidAndSubmit(){
            this.$refs['refDataForm'].validate((valid) => {
                //提示信息，是否报错
                this.$confirm('请核对信息, 是否继续保存?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.handleSubmit();
                    }).catch(() => {
                                
                    });
               
            }) 

        },
        //进行提交
        handleSubmit(){
            console.log(this.dataForm)
            addupdateVehicleStoreage(this.dataForm).then(res=>{
                if(res.success){
                    this.$message.success("提交成功");
                    this.handleClose();
                }else{
                    this.$message.error("提交失败");
                }
            })
        },

        handleClose() {
            const obj = { path: "/vehicle-insure/list" };
            this.$tab.closeOpenPage(obj);
        },
    }
}
</script>